"use client";
export { default as BodyLong } from "./BodyLong.js";
export { default as BodyShort } from "./BodyShort.js";
export { default as Detail } from "./Detail.js";
export { default as ErrorMessage, } from "./ErrorMessage.js";
export { default as Heading } from "./Heading.js";
export { default as Ingress } from "./Ingress.js";
export { default as Label } from "./Label.js";
//# sourceMappingURL=index.js.map